import React from 'react'

import theCalf from '../../images/THE-CALF.jpg'
import theCalf2 from '../../images/THE CALF 2.jpg'
import theCalf3 from '../../images/THE CALF 3.jpg'
import theCalf4 from '../../images/THE CALF 4.jpg'

function TheCalf() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={theCalf}
            className="project-image" />
          <img
            src={theCalf2}
            className="project-image" />
          <img
            src={theCalf3}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>The Calf</h1>
          <p className="Project-text">
            <strong>Short Film
              <br />
New Zealand Film Commission
              <br />

Directors: Mathew Sunderland, Simon London
              <br />
              2019
              <br />
              <br />

Casting + Rehearsal + On Set Acting Coach
<br />
Coached the 3 lead actors (ages 11, 13, 13)

            </strong>
          </p>
          <p className="Project-testimonial">
            "You did an excellent job getting me out of my comfort zone to get anything accomplished. You always pushed me harder because you knew I could do better. You always acted like a best friend to me so I always felt comfortable working around you. You always had a positive attitude which was really good especially since i was grumpy on the night shoots. And after every scene u always made sure I was ok and comfortable with what was happening.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Jack Goodwyn Archer - lead actor
</strong>
          </h6>
          <p className="Project-testimonial">
            "Prodégé to NZ’s coaching legend Miranda Harcourt, Ella was with us throughout the casting process and then all the way through pre production, workshops, rehearsals and finally on set. She’s got an incredible ability to bring the best out of young actors.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Simon London, director 

</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default TheCalf
